import axios from 'axios'
import {Message} from 'element-ui'
let onceError = false // 关闭token失效连续报错

axios.defaults.timeout = 60000

// request interceptor
axios.interceptors.request.use(
    config => {
        // do something before request is sent
    
        // config.headers['X-Access-Token'] = ''
        config.headers.lang = 'zh-CN';
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
axios.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        // console.log('5555',response)
        // const res = response.data
        // if the custom code is not 20000, it is judged as an error.
        if (!response.data.flag) {
            Message({
                message: response.data.msg || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(new Error(response.data.msg || 'Error'))
        } else {
            onceError = false
            return response
        }
    },
    error => {
        console.log('err' + error) // for debug
        Message.closeAll()
        Message({
            message: error.msg ? error.msg : '请求超时',
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export function get(url, params, header, forResponse) {
    return new Promise((resolve, reject) => {
        axios.get(process.env.VUE_APP_BASE_API + url, Object.assign({
            params: params
        }, header || {})).then(res => {
            if (forResponse) resolve(res)
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}



export function post(url, params, header, forResponse) {
    return new Promise((resolve, reject) => {
        console.log('sss',process.env)
        // axios.post(process.env.VUE_APP_BASE_API + url, Object.assign(params || {}, header || {})).then(res => {
        axios.post(process.env.VUE_APP_BASE_API + url, params, {
            headers: header || {}
        }).then(res => {
            if (forResponse) resolve(res)
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}







// WEBPACK FOOTER //
// ./src/utils/request.js